var _jsxFileName = "/var/home/clovis/Documents/Mangane/app/soapbox/components/progress_circle.tsx";
import classNames from 'classnames';
import React from 'react';
const ProgressCircle = ({
  progress,
  radius = 12,
  stroke = 4,
  title
}) => {
  const progressStroke = stroke + 0.5;
  const actualRadius = radius + progressStroke;
  const circumference = 2 * Math.PI * radius;
  const dashoffset = circumference * (1 - Math.min(progress, 1));
  return /*#__PURE__*/React.createElement("div", {
    title: title,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 18,
      columnNumber: 5
    }
  }, /*#__PURE__*/React.createElement("svg", {
    width: actualRadius * 2,
    height: actualRadius * 2,
    viewBox: `0 0 ${actualRadius * 2} ${actualRadius * 2}`,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 19,
      columnNumber: 7
    }
  }, /*#__PURE__*/React.createElement("circle", {
    className: "stroke-gray-400",
    cx: actualRadius,
    cy: actualRadius,
    r: radius,
    fill: "none",
    strokeWidth: stroke,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 24,
      columnNumber: 9
    }
  }), /*#__PURE__*/React.createElement("circle", {
    className: classNames('stroke-primary-800', {
      'stroke-danger-600': progress > 1
    }),
    style: {
      strokeDashoffset: dashoffset,
      strokeDasharray: circumference
    },
    cx: actualRadius,
    cy: actualRadius,
    r: radius,
    fill: "none",
    strokeWidth: progressStroke,
    strokeLinecap: "round",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 32,
      columnNumber: 9
    }
  })));
};
export default ProgressCircle;